export const baseStyleId = 'base-style';
export const generatedStyleId = 'generated-style';
